<div class="border-0 px-4 py-1 scroll-container" ref="ViewEntityType">
  <div class="d-flex justify-content-between align-items-center mb-1 me-4">
    <NavigationBackButton/>
  </div>
  <div class="card-header card-header-primary shadow rounded-lg mt-2">
    <div class="nav-tabs-navigation p-0">
      <div class="nav-tabs-wrapper">
        <ul class="nav nav-tabs " data-tabs="tabs">
          <li class="border rounded-lg me-2 nav-item mb-3" v-for="(tab, index) in tabs" :key="index"
            :class="[ active_tab === tab ? 'active' : 'inactive' ]" @click="set_active_tab(tab)">
            <a class="text-white text-decoration-none text-xs nav-link" href="#profile" data-toggle="tab">
              {{ tab }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="glassy-bg rounded-lg border-0 shadow mt-2">
    <div class="card-body rounded-lg">
      <div v-if="active_tab === 'Fields Required' ">
        <EntityTypeAttributes :entity_type_id="entity_type_id" />
      </div>

        <div v-if="active_tab === 'Forms'">
          <CreateForms/>
        </div>

        <div v-if="active_tab === 'Templates'">
          <p class="mt-2 fw-bold text-xs">Assigned Templates</p>

          <div class="table-responsive text-xs">
            <table class="table table-hover align-middle mb-0">
              <thead class="custom-header">
                <tr>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">ID</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Template Name</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Template Type</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Date Uploaded</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Date Modified</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start w-25">Actions</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="template in manage_template" :key="template.id">
                  <!-- Parent row -->
                  <tr :class="[
                'parent-row',
                template.template_type !== 'contract' ? 'cursor-pointer' : '',
                is_template_expanded(template.id) ? 'table-active' : ''
              ]" @click="template.template_type !== 'contract' ? toggle_template_expansion(template.id) : null">
                    <td class="text-xs text-muted ps-3">
                      <code class="text-muted">{{ template.id }}</code>
                    </td>
                    <td class="text-xs fw-semibold">
                      <div class="d-flex align-items-center gap-2">
                        <span>{{ template.template_name }}</span>

                        <!-- Contract count chip for annexures -->
                        <span v-if="template.template_type !== 'contract'" :class="[
                      'badge rounded-pill text-xs',
                      get_linked_contracts(template.id).length > 0 ? 'bg-success-subtle text-dark' : 'bg-warning-subtle text-dark'
                    ]">
                          {{ get_linked_contracts(template.id).length > 0
                          ? `${get_linked_contracts(template.id).length}
                          contract${get_linked_contracts(template.id).length > 1 ? 's' : ''}`
                          : 'No contracts' }}
                        </span>

                        <!-- Chevron button -->
                        <button
                            v-if="template.template_type !== 'contract'"
                            class="rounded-full border border-gray-300 w-7 h-7 flex items-center justify-center chevron-toggle"
                            :class="{ 'rotate-180': is_template_expanded(template.id) }"
                            @click.stop="toggle_template_expansion(template.id)"
                          >
                          <i class="bi bi-chevron-down text-xs"></i>
                        </button>
                      </div>
                    </td>
                    <td class="text-xs">
                      <span :class="[
                            'badge fw-normal text-xs',
                            template.template_type === 'contract' ? 'bg-primary-subtle text-primary' : 'bg-purple-subtle text-dark'
                          ]">
                        {{ template.template_type.charAt(0).toUpperCase() + template.template_type.slice(1) }}
                      </span>
                    </td>
                    <td class="text-xs ">
                      <small>{{ template.date_uploaded }}</small>
                    </td>
                    <td class="text-xs">
                      <small>{{ template.date_modified }}</small>
                    </td>
                    <td>
                      <div class="d-flex flex-wrap gap-2">
                        <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                          @click.stop="select_template(template, 'view')">
                          View
                        </button>
                        <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                          @click.stop="select_template(template)" data-bs-toggle="modal"
                          data-bs-target="#update_trust_template">
                          Update
                        </button>
                        <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                          @click.stop="configure_template(template.id)">
                          Configure
                        </button>
                        <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                          @click.stop="select_entity_type_template(template.id)" data-bs-toggle="modal"
                          data-bs-target="#assign_workflow">
                          Workflow
                        </button>
                      </div>
                    </td>
                  </tr>

                  <!-- Expanded sub-rows for annexures -->
                  <tr v-if="template.template_type !== 'contract' && is_template_expanded(template.id)"
                    class="expand-row bg-light">
                    <td colspan="6" class="p-0">
                      <div class="expand-section">
                        <!-- Expand header -->
                        <div class="d-flex justify-content-between align-items-center p-3 bg-purple-light border-bottom">
                          <div class="d-flex align-items-center gap-2">
                            <span class="text-xs fw-bold">Linked Contracts</span>
                          </div>
                          <button
                          class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                          data-bs-toggle="modal"
                          data-bs-target="#assign_contract_modal"
                          @click="fetch_contracts(template.id)"
                        >
                          Assign to Contract
                        </button>
                        </div>

                        <!-- Empty state -->
                        <div v-if="get_linked_contracts(template.id).length === 0" class="text-center py-5 text-muted">
                          <i class="bi bi-inbox fs-1 mb-2 opacity-50"></i>
                          <p class="text-xs mb-0">
                            No contracts linked yet. Click <strong>Assign to Contract</strong> to link one.
                          </p>
                        </div>

                        <!-- Contract sub-rows -->
                        <div v-else class="sub-contracts">
                          <div v-for="linked in get_linked_contracts(template.id)" :key="linked.id"
                            class="sub-contract-row d-flex align-items-center p-3 border-bottom border-dashed hover-bg-purple">
                            <!-- Tree connector -->
                            <div class="tree-connector me-3"></div>

                            <div class="sub-id text-xs text-muted me-3">
                              <code class="text-muted">{{ linked.id }}</code>
                            </div>
                            <div class="sub-name text-xs fw-semibold flex-grow-1 me-3">
                              {{ linked.template_name }}
                            </div>
                            <div class="sub-type me-3">
                              <span class="bg-primary-subtle text-dark text-xs">
                                {{ linked.template_type }}
                              </span>
                            </div>
                            <div class="sub-date text-xs me-3">
                              <small>{{ linked.date_uploaded }}</small>
                            </div>
                            <div class="sub-date text-xs me-3">
                              <small>{{ linked.date_modified }}</small>
                            </div>
                            <div class="d-flex gap-2">
                              <button class="btn btn-primary-dark btn-sm text-xs" @click.stop="select_template(linked, 'view')">
                                View
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>

            <!-- Empty state for no templates -->
            <div v-if="!loading_templates && manage_template.length === 0" class="text-center py-5 text-xs text-muted">
              <i class='bx bx-file-blank fs-1 mb-2'></i>
              <p>No assigned templates available. <a href='/view_template' class="text-dark fw-bold">Assign
                  templates</a> to get started!</p>
            </div>

            <!-- Loading spinner -->
            <div v-if="loading_templates" class="text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="active_tab === 'Approval Rules'">
          <div class="text-center py-4">
            <ManageApprovalRules />
          </div>
        </div>

        <div v-if="active_tab === 'Invoice Steps'">
          <InvoiceSteps />
        </div>

        <div v-if="active_tab === 'Compliance'">
          <ComplianceRules />
        </div>

        <div v-if="active_tab === 'Sub-Entities'">
          <AssignedSubEntities />
        </div>
        <div v-if="active_tab === 'Widgets'">
          <WidgetManagement :entity_type_id="entity_type_id" />
        </div>
      <!-- </div> -->
    </div>
  </div>
</div>

<!-- View Template Modal -->
<div v-if="preview_modal" @click.self="preview_modal = false">
  <FilePreviewComponent :presigned_url="selected_template.presigned_url" @close="close_the_file_preview"
    :key="selected_template.presigned_url" />
</div>

<!-- Update Template Modal -->
<teleport to="body">
  <div class="modal fade" id="update_trust_template" tabindex="-1" aria-labelledby="update_trust_template_label"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 custom-header shadow-lg">
          <h5 class="modal-title text-xxs" id="update_template_label">
            Update Template
          </h5>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <div class="mb-3">
            <label for="update_template_name" class="modal-form-label form-label text-xxs">Template name</label>
            <input v-model="selected_template.template_name"
              class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" type="text"
              placeholder="Template name" />
          </div>

          <div class="mb-3">
            <label for="update_template_file" class="modal-form-label form-label text-xxs">Upload new template</label>
            <input class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
              id="update_template_file" type="file" @change="handle_file_selection" />
          </div>
        </div>

        <div class="modal-footer border-0 p-2 d-flex justify-content-end">
          <button type="button" class="btn btn-primary-dark text-xxs btn-sm shadow-sm" @click="update_template"
            data-bs-dismiss="modal">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</teleport>

<!-- Assign Workflow Modal -->
<teleport to="body">
<div class="modal fade" id="assign_workflow" tabindex="-1" aria-labelledby="assign_workflow_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="assign_workflow_label">Assign Workflow</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <GlobalTable
          v-if="workflows.length > 0"
          :headers="workflows_table_headers"
          :data="workflows"
          :key="workflows"
          table_id="workflow_assignment_table"
        >
          <template #actions="{ row }">
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                :id="'switch_' + row.id"
                :checked="assigned_workflow.includes(row.id)"
                @change="toggle_assignment(row.id)"
              >
              <label class="form-check-label" :for="'switch_' + row.id">
                {{ assigned_workflow.includes(row.id) ? 'Assigned' : 'Unassigned' }}
              </label>
            </div>
          </template>
        </GlobalTable>
      </div>
    </div>
  </div>
</div>
</teleport>
<!-- Assign Contracts Modal -->
<teleport to="body">
  <div class="modal fade" id="assign_contract_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header custom-header">
          <h5 class="modal-title text-xxs font-weight-bolder text-white opacity-7">
            Assign Contracts to {{ selected_template.template_name }}
          </h5>
          <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body py-3">
          <div class="table-responsive">
            <table v-if="table_safe_contracts.length > 0" class="table table-hover w-100 display nowrap" id="contracts_table">
              <thead class="custom-header">
                <tr>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">No</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Contract Name</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Assign</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in table_safe_contracts" :key="row.id">
                  <td class="text-xxs text-start ps-3">{{ index + 1 }}</td>
                  <td class="text-xxs text-start">{{ row.template_name }}</td>
                  <td class="text-xxs text-start">
                    <div class="form-check form-switch d-flex">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        v-model="row.is_assigned"
                        @change="row.is_assigned ? assign_contract(row) : unassign_contract(row)"
                        :disabled="row.isLoading"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div v-else class="text-center py-5 text-muted text-xs">
              No contracts available to assign.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>